<template>
  <div class="shadow rounded-1">
    <h2 class="text-center pt-3">Jumlah Penerima Sertifikat Penghargaan Per Provinsi ({{ filterTahun }})</h2>

    <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['filterTahun', 'filterBulan'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      filter: {
        type: 'year',
        value1: String(new Date().getFullYear()),
      },
      listYear: Array.from({ length: 11 }, (_, i) => String(new Date().getFullYear() - i)),

      series: [
        {
          name: 'Jumlah Penerima Penghargaan',
          data: [0],
        },
      ],
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ['0'],
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            style: {
              colors: '#78909c',
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
      },
    }
  },
  methods: {
    handleFilter() {
      this.getJumlahPenerimaPenghargaan()
    },

    async getJumlahPenerimaPenghargaan() {
      let val = {
        labels: ['0'],
        series: [0],
      }

      const res = await axios.get(
        `${this.baseapiPengendalian}api/dashboard/getJumlahSertifikatPerProvinsi?tahun=${this.filterTahun}&bulan=${this.filterBulan}`,
        this.getApiOption(),
      )
      const resData = res.data.data

      val = {
        labels: resData.map((d) => d.provinsi),
        series: resData.map((d) => d.jumlah),
      }

      this.series = [
        {
          name: 'Jumlah Penerima Penghargaan',
          data: val.series,
        },
      ]
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          categories: val.labels,
        },
      }
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  watch: {
    filterTahun: {
      handler() {
        this.getJumlahPenerimaPenghargaan()
      },
      immediate: true,
    },
    filterBulan() {
      this.getJumlahPenerimaPenghargaan()
    },
  },
}
</script>
